export enum ApiType {
  Axios = "Axios",
  Cat2 = "Cat2",
  Cat3 = "Cat3",
  Advertising = "Advertising",
  Orders = "Orders",
  Tracker = "Tracker",
  GUJ = "GUJ",
  CSRF = "CSRF",
  Foundation = "Foundation",
}

export class ApiError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, ApiError.prototype);
  }

  name = "ApiError";
}

export interface IArtsFacetsRequest {
  o?: string;
  is_for_pda?: boolean;
  offset?: string;
  limit?: number;
  only_abonement_exclusives?: boolean;
  only_abonement_arts?: boolean;
  only_discount_arts?: boolean;
  only_litres_subscription_arts?: boolean;
  only_selfpublished_arts?: boolean;
  only_high_rated?: boolean;
  only_litres_exclusives?: boolean;
  only_drafts?: boolean;
  only_safe_content?: boolean;
  art_types?: ("text_book" | "audiobook" | "podcast")[];
  languages?: [];
}
